export const DOCUMENT_HISTORY_ACTION = {
  REQUESTED: 'REQUESTED',
  UPLOADED: 'UPLOADED',
  REJECTED: 'REJECTED',
  APPROVED: 'APPROVED',
};
